import React from 'react'
import {Path} from "../../../../public/path";
import {CaretDownOutlined, DownOutlined} from '@ant-design/icons';
import {
    Table,
    Tooltip,
    DatePicker,
    Button,
    Input,
    Modal,
    Popover,
    Popconfirm,
    Select, Menu, Dropdown,
} from "antd";

moment.locale('zh-cn');
import Link from "react-router-dom/Link";
import zh_CN from "antd/lib/locale-provider/zh_CN";
import Api from "../../../../public/api";
import {URL_MXD_BOOST_DISABLE, URL_MXD_BOOST_ENABLE, URL_MXD_BOOST_PROMOTO} from "../../../../public/variables";
import Message from "../../../../cmpts/ant/Message";
import Util from "../../../../public/utils";

const {RangePicker} = DatePicker;
const Option = Select.Option;
import warning from "../../../../../images/market/distribution/warning2.png";
import Price from "../../../prizeunlock/common/Price";
import moment from "moment";
import ZkSearchGroup from "../../../../common/search/zkSearchGroup";
import ZkInput from "../../../../common/search/zkInput";
import ZkSelect from "../../../../common/search/zkSelect";
import ZkTable from "../../../../common/table/zkTable";
import ZkHeadText from "../../../../common/table/zkHeadText";
import QuestionTip from "../../../../common/questionTip";
import ZkOptBtns from "../../../../common/table/zkOptBtns";
import ZkModal from "../../../../common/modal/zkModal";
import Store from "../../../../store";

const ExpiredText = '拼团功能已过期，续费后方可继续使用';

let arr = 'general_group_activity_management'
let arr1 = 'general_group_activity_management1'
let currentPageNum=1

class ActiveList extends React.Component {
    constructor(props) {
        super(props);
        this.getActivityList = this.getActivityList.bind(this);
        this.getColums = this.getColums.bind(this);
        this.state = {
            pagInfo: {
                pageSize: 10,
                pageNum: 1,
                total: ''
            },
            queryParams: {
                groupbuyName: '',
                status: 9, //筛选全部状态时为 9
            },
            activityList: [],
            promotolink: '',//推广链接
            qrcode: '', //推广二维码
            closeVisible: false,//关闭活动的提示弹窗
            openVisible: false,//活动开启的弹窗.
            enableData: {}, //活动开启的传参
            datePicker: null,
            isExpired: false
        };
        this.getAllDisTriPayment = '当前活动扣除手续费和返现之后的实收金额'
    }

    componentWillMount() {
        let str = Store.getQueryParams(arr)
        let str1 = Store.getQueryParams(arr1)
        if(this.props.groupBooktype == 'common'){
            if(str && str.params){
                this.setState({
                    queryParams:str.params
                })
            }
            if(str && str.pageNum){
                currentPageNum = str.pageNum
            }
        }else if(this.props.groupBooktype == 'isCommon'){
            if(str1 && str1.params){
                this.setState({
                    queryParams:str1.params
                })
            }
            if(str1 && str1.pageNum){
                currentPageNum = str1.pageNum
            }
        }
    }

    componentDidMount() {
        this.copyFun('ModalTgValueBtn');
        this.copyFun('ModalTgValueBtn1');
        this.copyFun('ModalTgValueBtn2');
        this.setExpired(this.props.isExpired)
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.activeKey == "1") {
            // this.getActiveList(1, "")
        }
        this.setExpired(nextProps.isExpired)
    }

    setExpired = (val) => {
        this.setState({
            isExpired: val
        })
    };

    isLadder() {
        if (this.props.type == 'ladder') {
            return true;
        } else {
            return false;
        }
    }

    copyFun(id) {
        let clipboard = new ClipboardJS('#' + id);
        clipboard.on('success', function (e) {
            Message.success("复制链接成功！");
            e.clearSelection();
        });
        clipboard.on('error', function (e) {
            alert('请选择“拷贝”进行复制!')
        });
    }

    taskNameChange(e) {
        let queryParams = this.state.queryParams;
        queryParams.groupbuyName = e.target.value;
        this.setState({
            queryParams: queryParams
        })
    }

    taskStatusChange(val) {
        let queryParams = this.state.queryParams;
        queryParams.status = val;
        this.setState({
            queryParams: queryParams
        })
    }

    getActivityList(bodyParams, pageNum, pageSize) {
        currentPageNum = pageNum

        if(this.props.groupBooktype == 'common'){
            Store.setAddFriendQueryParams(arr,this.state.queryParams,currentPageNum)
        }else if(this.props.groupBooktype == 'isCommon'){
            Store.setAddFriendQueryParams(arr1,this.state.queryParams,currentPageNum)
        }
        let params = {
            pageNum: pageNum,
            pageSize: pageSize,
        };
        return new Promise((resolve) => {
            if (this.isLadder()) {
                Api.getGroupBuyLadderActivityList(params, bodyParams, (data) => {
                    resolve(data)
                }, () => {
                })
            } else {
                Api.getGroupBuyActivityList(params, bodyParams, (data) => {
                    resolve(data)
                }, () => {
                })
            }
        });

    }

    setVal(key, val) {
        this.setState({
            [key]: val
        })
    }

    getVal(key) {
        return this.state[key]
    }

    hideModal(key) {
        this.setVal(key, false);
    }

    getPromotoInfo(id, key) { //推广按钮
        this.setState({
            [key]: true
        });
        Api.getGroupBuyPromoInfo(id, (data) => {
            this.setState({
                promotolink: data.url, //推广链接
                posterUrl: data.posterUrl,
                qrcode: data.qrcode,
            })
        })
    }

    disabledDate(current) {
        return current && current.valueOf() <= moment().valueOf()
    }

    openChange() {
        Util.enableScroll()
    }

    setStatus(record, flag) { //flag 0 关闭 1 开启
        let id = record.groupbuyId;
        let status = record.status;
        this.setVal('currentStatus', status);
        this.setVal('idSelected', id);
        let key = flag == 0 ? 'closeVisible' : 'openVisible';
        let enableData = this.state.enableData;
        enableData.endTime = record.endTime;
        this.setVal('datePicker', moment(record.endTime));
        this.setVal(key, true);//显示模态框
    }

    closeActivity() { //活动关闭
        let id = this.getVal('idSelected');
        Api.TurnOffGroupBuyActivity(id, () => {
            Message.success('活动关闭成功');
            this.setVal('closeVisible', false);
            this.listTable.refresh()
        }, () => {
            Message.error('活动关闭失败');
        })
    }

    changeVisible(index, visible) {//更多的popOver
        let list = this.state.activityList;
        list[index].visible = visible;
        this.setState({
            activityList: list
        })
    }

    delete() {//删除
        let activityData = this.getVal('deleteActivityData');
        if (activityData) {
            Api.deleteGroupBuyActivity(activityData.groupbuyId, (data) => {
                Message.success("删除活动成功");
                this.listTable.refresh();
                this.deleteModal.hide();
            }, (err) => {
                Message.success("删除活动失败，请重新操作");
            })
        }
    }

    timeChange(val) {
        let enableData = this.state.enableData;
        enableData.endTime = new Date(val).getTime();
        this.setState({
            enableData: enableData,
            datePicker: val
        })
    }

    openActivity() { //活动开启
        let enableData = this.state.enableData;
        // if (Util.isNull(enableData.startTime)) {
        //     Message.warning("请选择活动开始时间", null, null, true);
        //     return false;
        // }
        if (Util.isNull(enableData.endTime)) {
            Message.error("请选择活动结束时间");
            return false;
        }
        // if (enableData.endTime < enableData.startTime) {
        //     Message.warning("活动结束时间应大于活动开始时间", null, null, true);
        //     return false;
        // }
        if (enableData.endTime.valueOf() <= new Date()) {
            Message.error("活动结束时间必须晚于现在时间");
            return false;
        }
        enableData.groupbuyId = this.state.idSelected;
        Api.TurnOnGroupBuyActivity(enableData, () => {
            Message.success('已成功开启活动');
            this.setVal('openVisible', false);
            this.listTable.refresh();
        })
    }

    goFansReport(Id) { //兑换码记录
        this.props.history.push({
            pathname: Path.getMarketRedeemCodeData() + Id,
            query: {
                Id: Id
            }
        });
    }

    goDataReport(id) { // 活动数据
        if (this.props.type == 'ladder') {
            this.props.history.push(Path.getMarketGroupBuyManage() + 'ladder?tabName=report&activityId=' + id);
        } else {
            this.props.history.push(Path.getMarketGroupBuyManage() + 'common?tabName=report&activityId=' + id);
        }
    }

    goOrderList(id) {
        if (this.props.type == 'ladder') {
            this.props.history.push(Path.getMarketGroupBuyManage() + 'ladder?tabName=order&activityId=' + id);
        } else {
            this.props.history.push(Path.getMarketGroupBuyManage() + 'common?tabName=order&activityId=' + id);
        }
    }

    goGroupList(id) {
        if (this.props.type == 'ladder') {
            this.props.history.push(Path.getMarketGroupBuyManage() + 'ladder?tabName=group&activityId=' + id);
        } else {
            this.props.history.push(Path.getMarketGroupBuyManage() + 'common?tabName=group&activityId=' + id);
        }
    }

    getAddPage() {
        if (this.isLadder()) {
            return Path.getGroupBuyLadderActivityCreate();
        } else {
            return Path.getGroupBuyActivityCreate();
        }
    }

    query(type,params) {
        if (type == 'reset'){
            params.status=9
        }
        this.setState({
            queryParams: params
        },()=>{
            if(this.props.groupBooktype == 'common'){
                Store.setAddFriendQueryParams(arr,this.state.queryParams,currentPageNum)
            }else if(this.props.groupBooktype == 'isCommon'){
                Store.setAddFriendQueryParams(arr1,this.state.queryParams,currentPageNum)
            }
        })
    }

    deleteConfirm(record) {
        this.setState({
            deleteActivityData: record
        });
        this.deleteModal.show();
    }

    goCopyActivity(groupbuyId) {
        let url = this.isLadder() ? Path.getGroupBuyLadderActivityCopy() : Path.getGroupBuyActivityCopy()
        this.props.history.push(url + groupbuyId)
    }

    getColums() {
        return [
            {
                dataIndex: 'groupbuyName',
                title: '活动信息',
                fixed: 'left',
                width: '230px',
                render: (text, record) => (
                    <ZkHeadText headUrl={record.coverImgUrl} headText={text}/>
                )
            },
            {
                dataIndex: 'price',
                title: '商品原价',
                width: '140px',
                render: (text, record, index) => (
                    record.originalPriceRadio ? <Price price={record.originalPrice}/> : ''
                )
            },
            {
                dataIndex: 'groupbuyPrice',
                title: '拼团价',
                width: '190px',
                render: (text, record, index) => (
                    <Price price={record.groupbuyPrice}/>
                )
            },
            {
                dataIndex: 'endTime',
                title: '活动结束时间',
                width: '200px',
                render: (text, record) => (
                    <ul>
                        <li>{new Date(record.endTime).format('yyyy-MM-dd hh:mm')}</li>
                    </ul>
                )
            },
            {},
            {
                dataIndex: 'status',
                title: '活动状态',
                width: '135px',
                render: (status) => (
                    <div>
                        {status == 0 ? <span className="text-before">未开始</span> : ''}
                        {status == 1 ? <span className="text-success">进行中</span> : ''}
                        {status == -1 ? <span className="text-over">已结束</span> : ''}
                    </div>
                )
            },
            {
                dataIndex: 'totalCustomer',
                title: '参与用户',
                width: '90px',
                render: (text, record, index) => (
                    <span>{record.totalCustomer}</span>
                )
            },
            {
                dataIndex: 'pendingOrder',
                title: '拼团中订单',
                width: '110px',
                render: (text, record, index) => (
                    <span>{record.pendingOrder}</span>
                )
            },
            {
                dataIndex: 'rebateAmount',
                title: () => {
                    return (
                        <div className={'goodsStock'}>
                            <span className={'text'}>成团订单数</span>
                            <QuestionTip title={'拼团成功的客户数量'}/>
                        </div>
                    )
                },
                width: '125px',
                render: (text, record, index) => (
                    <span>{record.successOrder}</span>
                )
            },
            {
                dataIndex: 'totalAmount',
                title: () => {
                    return (
                        <div className={'goodsStock'}>
                            <span className={'text'}>订单实付金额</span>
                            <QuestionTip title={'拼团活动带来的总付款金额（包含退款）'}/>
                        </div>
                    )
                },
                width: '160px',
                render: (text, record, index) => (
                    <Price price={record.totalAmount}/>
                )
            },
            {
                dataIndex: 'stock',
                title: '剩余库存',
                width: '120px',
            },
            {
                dataIndex: 'key',
                title: '操作',
                align: 'center',
                fixed: 'right',
                width: '154px',
                render: (text, record, index) => (
                    <ZkOptBtns>
                        {
                            this.state.isExpired ? <Tooltip title={ExpiredText}> <span className={'text-gray'}>推广
                            </span></Tooltip> : <span className={'text-primary'}
                                                      onClick={this.getPromotoInfo.bind(this, record.groupbuyId, 'visible')}>推广
                        </span>
                        }
                        {
                            this.state.isExpired ? <Tooltip title={ExpiredText}>
                                <li className='text-gray'>编辑</li>
                            </Tooltip> : <Link
                                to={(this.isLadder() ? Path.getGroupBuyLadderActivityEdit() : Path.getGroupBuyActivityEdit()) + record.groupbuyId}>
                                <li>编辑</li>
                            </Link>
                        }

                        <Dropdown placement="bottomRight" arrow overlay={<Menu className={'tableOptMoreBtns rowTwo'}>
                            {
                                record.goodsType == 3 ?
                                    <Menu.Item key="0" onClick={this.goFansReport.bind(this, record.redeemcodeId)}>
                                                <span className='text-primary'>
                                                    兑换记录
                                                </span>
                                    </Menu.Item> : ''
                            }
                            <Menu.Item key="2" onClick={this.goOrderList.bind(this, record.groupbuyId)}>
                                <span className={'text-primary'}>订单管理</span>
                            </Menu.Item>
                            <Menu.Item key="3" onClick={this.goDataReport.bind(this, record.groupbuyId)}>
                                <span className={'text-primary'}>
                                                活动数据
                                            </span>
                            </Menu.Item>
                            <Menu.Item key="4" onClick={this.goGroupList.bind(this, record.groupbuyId)}>
                                <span className={'text-primary'}>拼团情况</span>
                            </Menu.Item>
                            <Menu.Divider/>
                            {
                                record.status == 1 ?
                                    <Menu.Item key="5" onClick={this.setStatus.bind(this, record, 0)}>
                                        <span className={'text-primary'}>关闭活动</span>
                                    </Menu.Item> :
                                    this.state.isExpired ?
                                        <Menu.Item key="5">
                                            <Tooltip title={ExpiredText}><span
                                                className={'text-gray'}>开启活动</span></Tooltip>
                                        </Menu.Item> :
                                        <Menu.Item key="5" onClick={this.setStatus.bind(this, record, 1)}>
                                            <span className={'text-primary'}>开启活动</span>
                                        </Menu.Item>
                            }
                            {
                                this.state.isExpired ? <Menu.Item key="6">
                                        <Tooltip title={ExpiredText}>
                                            <li className='text-gray'>复制活动</li>
                                        </Tooltip>
                                    </Menu.Item> :
                                    <Menu.Item key="6" onClick={this.goCopyActivity.bind(this, record.groupbuyId)}>
                                        <span className={'text-primary'}>复制活动</span>
                                    </Menu.Item>
                            }
                            <Menu.Item key="7" onClick={this.deleteConfirm.bind(this, record)}>
                                <span className={'text-primary'}>删除活动</span>
                            </Menu.Item>
                        </Menu>}>
                            <a className="ant-dropdown-link" onClick={e => e.preventDefault()}>
                                更多<DownOutlined/>
                            </a>
                        </Dropdown>
                    </ZkOptBtns>
                )
            },
        ];
    }


    render() {
        return (
            <>
                <div className='searchPanel'>
                    {
                        this.state.isExpired ? <Tooltip title={ExpiredText}>
                            <Button className='create-btn' type="primary" disabled={true}>
                                新建活动
                            </Button>
                        </Tooltip> : <Link to={this.getAddPage()}> <Button className='create-btn'
                                                                           type="primary">
                            新建活动
                        </Button></Link>
                    }
                    <ZkSearchGroup onOk={this.query.bind(this,'ok')}
                                   onReset={this.query.bind(this,'reset')}
                                   btnBlock={false}>
                        <ZkInput title='活动名称：' defaultValue={this.state.queryParams.groupbuyName} valueKey='groupbuyName' placeholder={'请输入要搜索活动名称'}/>
                        <ZkSelect title={'活动状态：'} valueKey='status'
                                  defaultValue={this.state.queryParams.status}>
                            <Option value={9}>全部状态</Option>
                            <Option value={1}>进行中</Option>
                            <Option value={-1}>已结束</Option>
                        </ZkSelect>
                    </ZkSearchGroup>
                </div>
                <ZkTable ref={r => this.listTable = r} owncolumns={this.getColums} queryAction={this.getActivityList}
                         params={this.state.queryParams} baseProps={{scroll: {x: 1600}}} currentPageNum={currentPageNum}/>

                {/*任务推广*/}
                <Modal title="推广"
                       visible={this.state.visible}
                       wrapClassName='tgModal'
                       onCancel={this.hideModal.bind(this, 'visible')}
                       onOk={this.hideModal.bind(this, 'visible')}
                       footer={null}
                >
                    <div className="">
                        <img className="TableModalPic"
                             src={'data:image/jpeg;base64,' + this.state.qrcode}/>
                        <a className="goodsTableTooltip"
                           href={'data:image/jpeg;base64,' + this.state.qrcode}
                           download="二维码.png">下载二维码</a>
                        <div className="goodsCopyLink">
                            {/*<label className={'label70'}>推广链接:</label>*/}
                            {/*<label className={'label70'}></label>*/}
                            <Input type='text' className={'goodsTableLink'} value={this.state.promotolink}
                                   id='ModalTgValue'/>
                            <Button className="TableLinkBtn"
                                    id="ModalTgValueBtn" data-clipboard-target="#ModalTgValue"
                                    data-clipboard-action="copy"
                                    type={'primary'}
                            >复制</Button>
                        </div>
                        <p className="goodsTableLinkWord">复制链接，分享给更多的人</p>
                    </div>
                </Modal>

                {/*关闭活动*/}
                <Modal title='提示'
                       visible={this.state.closeVisible}
                       wrapClassName='tgModal'
                       onCancel={this.hideModal.bind(this, 'closeVisible')}
                       onOk={this.closeActivity.bind(this)}
                >
                    <div className={'turn-off-modal'}>
                        <img src={warning}/>
                        <p>当前活动正在进行中...</p>
                        <p>操作关闭，活动将自动结束，确认是否关闭 </p>
                    </div>
                </Modal>
                {/*开启活动  需要判断日期做 相应操作 */}
                <Modal title='提示'
                       visible={this.state.openVisible}
                       wrapClassName='tgModal'
                       onCancel={this.hideModal.bind(this, 'openVisible')}
                       onOk={this.openActivity.bind(this)}
                >
                    <div className={'turn-on-modal'}>
                        <span className='waring'><img src={warning}/>
                            {this.state.enableData.endTime > new Date().getTime() ? '当前活动已结束，操作开启，活动将自动开启，确认是否开启' : '当前活动已结束，操作开启活动，请修改结束时间'}
                        </span>
                        <div style={{'height': '20px'}}></div>
                        <div className={'modal-date'}>
                            <DatePicker onChange={this.timeChange.bind(this)}
                                        className={'inline-control'}
                                        placeholder={'结束时间'}
                                        disabledDate={this.disabledDate.bind(this)}
                                        showTime={true}
                                        style={{'width': '300px'}}
                                        value={this.state.datePicker}
                                        onOpenChange={this.openChange.bind(this)}
                                        getCalendarContainer={triggerNode => triggerNode.parentNode}
                            />
                            {/*<LocaleProvider locale={zh_CN}>*/}
                            {/*    <RangePicker*/}
                            {/*        onChange={this.timeChange.bind(this)}*/}
                            {/*        defaultValue={this.state.startTime > 0 ? [new moment(this.state.startTime), new moment(this.state.endTime)] : [null, null]}*/}
                            {/*        showTime*/}
                            {/*        separator="至"*/}
                            {/*    />*/}
                            {/*</LocaleProvider>*/}
                        </div>
                    </div>
                </Modal>
                <ZkModal ref={r => this.deleteModal = r} title='提示' onOk={this.delete.bind(this)}>
                    确定要删除活动<span
                    className='text-primary'>{this.state.deleteActivityData ? this.state.deleteActivityData.groupbuyName : ''}</span>吗？删除后不可恢复
                </ZkModal>
            </>
        );
    }

}

export default ActiveList;